/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_201Inputs */

const vi_carrier_status_201 = /** @type {(inputs: Carrier_Status_201Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hãng huỷ đơn hàng`)
};

/**

* @param {Carrier_Status_201Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_201 = /** @type {((inputs?: Carrier_Status_201Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_201Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_201(inputs)
});